export default __webpack_public_path__ + "static/media/twitter.8e92456f.svg";